<template>
    <div ref="lines" class="container"></div>
</template>

<script>
import echarts from 'echarts';
import {chartMerge} from 'echarts-config';
import {linesData} from '@/runtime-components/data';
export default {
    name: 'de-lines',
    props: {
        data: {
            type: Object,
            default: () => {
                return linesData;
            }
        },
        shows: {
            type: Boolean
        }, 
        legend: {
            type: String,
            default: '邮件营销, 联盟广告, 视频广告, 直接访问, 搜索引擎'
        }
    },
    data() {
        let chartIns = {
            chart: null,
            option: []
        };
        return {
            getChart() {
                return chartIns;
            }
        }
    },
    mounted() {
        this.initChart();
    },
    destroyed(){
        this.destroyChart();
    },
    watch: {
        legend(v) {
            let chart = this.getChart().chart;
            let legend = v.split(',');
            let series = this.dealData(this.data);
            chart && (chart.setOption({
                legend: {
                    data: legend
                }
            }));
            let option = chart.getOption();
            option.series = series;
            chart.setOption(option, true);
        },
        data: {
            handler(v) {
                let chart = this.getChart().chart;
                let series = this.dealData(v);
                chart && (chart.setOption({
                    xAxis: {
                        data: v.xData
                    }
                }));
                let option = chart.getOption();
                option.series = series;
                chart.setOption(option, true);
            },
            deep: true
        },
        shows() {
            let chart = this.getChart().chart;
            chart && (chart.setOption({
                legend: [{
                    show:  this.shows
                }]
            }));
        },
    },
    methods: {
        initChart(type) {
            let chartIns = this.getChart();
            //初始化设置主题 dark light
            window._CHART_THEMETYPE_ = type || 'dark';
            let series = this.dealData(this.data);
            let legend = this.legend.split(',');
            //echarts1
            const chart = chartMerge(
                {
                    chartType: 'lineBar'
                },{
                    tooltip: {
                        trigger: 'axis'
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: [{
                        type: 'category',
                        data: this.data.xData
                    }],
                    // legend:{
                    //     data: this.data.legend,
                    //     show: this.shows,
                    // },
                    legend: {
                        data: legend,
                        show: this.shows,
                    },                                                                                          
                    yAxis: {
                        type: 'value'
                    },
                    series: series,
                });
            if (!chartIns.chart) {
                chartIns.chart = echarts.init(this.$refs['lines']);
                chartIns.chart.setOption(chart);
                this.resizeChart = chartIns.chart.resize;
            }
        },
        dealData(data) {
            if (data) {
                let tempData = data.data.concat([]);
                let arr = [];
                let legend = this.legend.split(',');
                tempData.forEach((item,index)=>{
                    arr.push({
                        name: legend[index],
                        type: 'line',
                        stack: '总量',
                        data: item
                    });
                });
                return arr;
            }
        },
        destroyChart() {
            const chartIns = this.getChart();
            if(chartIns.chart){
               chartIns.chart.dispose();
               chartIns.chart = null;
            }
        }
    }
}
</script>

<style scoped>
@import url('~@/runtime-components/assets/common.css');
</style>
